/* Bundle selection motion for every product page (see iq-bundle-motion.css).
   Works with the theme's quantity breaks and the custom bundle blocks, and only reacts to the customer's own
   taps, so cards selected on page load stay still. The Cheertok bundle has its own motion and is left alone. */
(function () {
  'use strict';
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var CARDS = '.quantity-break, .iqe-card, .iqb-card, .iqtv-card, .db-card';
  var PANELS = '.quantity-break__variants, .iqe-body, .iqb-options';
  var ROOTS = 'quantity-breaks, .iqe, .iqb, .iqtv-size-bundle, .db';
  var ease = 'cubic-bezier(.22, 1, .36, 1)';
  var lastTouch = 0;
  ['pointerdown', 'keydown'].forEach(function (t) { document.addEventListener(t, function () { lastTouch = Date.now(); }, true); });
  function byCustomer() { return Date.now() - lastTouch < 1500; }

  function restart(el, cls, ms) {
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
    clearTimeout(el['_iqbm' + cls]);
    el['_iqbm' + cls] = setTimeout(function () { el.classList.remove(cls); }, ms);
  }

  function shine(host) {
    if (getComputedStyle(host).position === 'static') host.classList.add('iqbm-host');
    var old = host.querySelector(':scope > .iqbm-shine');
    if (old) old.remove();
    var s = document.createElement('span');
    s.className = 'iqbm-shine';
    s.setAttribute('aria-hidden', 'true');
    if (getComputedStyle(host).direction === 'rtl') s.classList.add('is-rtl');
    host.appendChild(s);
    setTimeout(function () { s.remove(); }, 1400);
  }

  // The just-opened panel takes its full height at once (the page around it never moves) and only its
  // contents fade up; opacity and transform don't touch layout.
  function reveal(panel) {
    if (!panel || !panel.getClientRects().length || !panel.animate) return;
    panel.animate([{ opacity: 0, transform: 'translateY(6px)' }, { opacity: 1, transform: 'none' }], { duration: 420, easing: ease });
  }

  // The visible add button for this bundle: inside the chosen card first, then anywhere in the bundle or product info.
  function addButton(card) {
    var sel = '.iqe-add, .iqb-add, .iqtv-add-btn, .db-add, .product-form__submit, [name="add"]';
    var scopes = [card, card.closest('.iqe, .iqb, .iqtv-size-bundle, .db'), card.closest('product-info, .product__info-container, .product__info-wrapper, section')];
    for (var i = 0; i < scopes.length; i++) {
      if (!scopes[i]) continue;
      var hit = Array.prototype.find.call(scopes[i].querySelectorAll(sel), function (b) { return b.getClientRects().length && !b.disabled; });
      if (hit) return hit;
    }
    return null;
  }

  // Each bundle plays the opening once per choice. Quantity taps re-select the same card (some bundles
  // clear and re-add the class, or re-render the card), so the card is remembered by its position.
  function sameAsLast(card) {
    var root = card.closest(ROOTS + ', .quantity-breaks-container') || document.body;
    var idx = Array.prototype.indexOf.call(root.querySelectorAll(CARDS), card);
    if (root._iqbmLast === idx) return true;
    root._iqbmLast = idx;
    return false;
  }

  function open(card) {
    if (card.closest('iq-cheertok-bundles') || sameAsLast(card)) return;
    restart(card, 'iqbm-open', 950);
    shine(card);
    reveal(card.querySelector(PANELS));
    var btn = addButton(card);
    if (!btn || !btn.getClientRects().length) return;
    setTimeout(function () {
      restart(btn, 'iqbm-cta', 1500);
      shine(btn);
    }, 420);
  }

  // Theme quantity breaks: each option is a radio followed by its card.
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('.quantity-breaks-container input[type="radio"]') || !input.checked || !byCustomer()) return;
    var card = input.nextElementSibling;
    if (card && card.matches('.quantity-break')) open(card);
  });

  // Custom bundles mark the chosen card with a class; react when the customer caused it.
  var seen = new WeakSet();
  function watch(root) {
    if (seen.has(root) || root.closest('iq-cheertok-bundles') || root.matches('quantity-breaks')) return;
    seen.add(root);
    new MutationObserver(function (list) {
      if (!byCustomer()) return;
      list.forEach(function (m) {
        var el = m.target;
        if (!el.matches(CARDS)) return;
        var was = String(m.oldValue || ''), on = el.classList.contains('is-selected') || el.classList.contains('is-active');
        if (on && !/\bis-(selected|active)\b/.test(was)) open(el);
      });
    }).observe(root, { subtree: true, attributes: true, attributeFilter: ['class'], attributeOldValue: true });
  }

  // The card already open when the page loads counts as the last choice, so tapping it again stays still.
  function remember() {
    document.querySelectorAll(ROOTS + ', .quantity-breaks-container').forEach(function (root) {
      if (root._iqbmLast !== undefined) return;
      var cards = root.querySelectorAll(CARDS);
      var on = Array.prototype.findIndex.call(cards, function (c) {
        var radio = c.previousElementSibling;
        return c.classList.contains('is-selected') || c.classList.contains('is-active') || (radio && radio.matches('input[type="radio"]') && radio.checked);
      });
      if (on > -1) root._iqbmLast = on;
    });
  }

  function scan() { document.querySelectorAll(ROOTS).forEach(watch); remember(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
